import { dayOffsetToDate } from '../shared'
import { demoUser } from '../tenants/tenant'
import {
  ProjectStatus,
  WbsItemCodeFormat,
} from '../../../domain/entity/ProjectEntity'

export const demoProject = {
  uuid: 'demo-project-uuid',
  lockVersion: 1,
  revision: 'demo-revision',
  children: [],
  code: 'demo',
  displayName: 'デモプロジェクト',
  officialName: 'デモプロジェクト',
  iconUrl: '',

  get scheduledDate() {
    return {
      startDate: dayOffsetToDate(-90),
      endDate: dayOffsetToDate(274),
    }
  },
  get actualDate() {
    // ProjectDetail.actualDate.endDateはstring型のため、進行中プロジェクト
    // （終了日未定）を空文字列で表す。
    return { startDate: dayOffsetToDate(-90), endDate: '' }
  },
  mainEmail: 'demo-project@example.com',
  division: {
    uuid: 'demo-division-uuid',
    displayName: 'デモ事業部',
    officialName: 'デモ事業部',
  },
  businessClient: {
    uuid: 'demo-client-uuid',
    displayName: 'デモ株式会社',
    officialName: 'デモ株式会社',
  },
  projectManager: demoUser,
  assigned: true,
  status: ProjectStatus.INPROGRESS,
  wbsItemCodeFormat: WbsItemCodeFormat.RANDOM,
}

export const demoFunctionDirectory = {
  uuid: 'demo-directory-project',
  externalId: 'demo-directory-project',
  name: 'プロジェクト',
  displayOrder: 1,
  defaultOpen: true,
  directories: [],
  functions: [
    {
      uuid: 'demo-function-project-plan',
      externalId: 'projectPlan.new.edit',
      name: 'プロジェクト計画',
      hidden: false,
      uiType: 'CUSTOM',
      displayOrder: 1,
      configurable: false,
    },
    // App.tsx builds every /tickets, /ticketLists route from this list
    // (functions.flatMap looking up view/pages/index.tsx's `components` map
    // by externalId) — without these two, ProjectPlanNew's addTicket flow
    // has nowhere to navigate to and the Tickets/TicketLists screens 404.
    {
      uuid: 'demo-function-tickets',
      externalId: 'ticket.list.edit',
      name: 'チケット一覧',
      hidden: false,
      uiType: 'CUSTOM',
      displayOrder: 2,
      configurable: false,
    },
    {
      uuid: 'demo-function-ticket-lists',
      externalId: 'ticketLists.edit',
      name: 'チケット管理表一覧',
      hidden: false,
      uiType: 'CUSTOM',
      displayOrder: 3,
      configurable: false,
    },
  ],
}
